<div class="nav__logo">
  <img src="assets/images/logo.svg" alt="HeatMap logo" />
</div>

<div class="nav__menu" *hmIfRole="[role.Viewer, role.Admin, role.SuperAdmin]">
  <a
    class="nav__menu-item"
    routerLink="/"
    routerLinkActive="nav__menu-item-icon_active"
    [routerLinkActiveOptions]="{ exact: true }"
    ddsTooltip="Home"
    tooltipInvokeType="hover"
    tooltipType="regular"
    tooltipSize="lg"
    tooltipPosition="right"
    [tooltipIndent]="10"
    [tooltipHasBeak]="true"
  >
    <ng-container *ngTemplateOutlet="svgIconHome"></ng-container>
  </a>

  <button
    type="button"
    class="nav__menu-item"
    hmHighlightRouterLink="/office-utilization"
    routerLinkActive="nav__menu-item-icon_active"
    ddsTooltip="Office utilization"
    tooltipInvokeType="hover"
    tooltipType="regular"
    tooltipSize="lg"
    tooltipPosition="right"
    [tooltipIndent]="10"
    [tooltipHasBeak]="true"
    (click)="openFilterPanel(filterPanelKey.BuildingUtilization)"
  >
    <ng-container *ngTemplateOutlet="svgIconBuilding"></ng-container>
  </button>

  <button
    type="button"
    class="nav__menu-item"
    hmHighlightRouterLink="/floor-utilization"
    routerLinkActive="nav__menu-item-icon_active"
    ddsTooltip="Floor utilization"
    tooltipInvokeType="hover"
    tooltipType="regular"
    tooltipSize="lg"
    tooltipPosition="right"
    [tooltipIndent]="10"
    [tooltipHasBeak]="true"
    (click)="openFilterPanel(filterPanelKey.FloorUtilization)"
  >
    <ng-container *ngTemplateOutlet="svgIconFloor"></ng-container>
  </button>

  <a
    *hmIfRole="[role.Admin, role.SuperAdmin]"
    [tooltipHasBeak]="true"
    [tooltipIndent]="10"
    class="nav__menu-item"
    ddsTooltip="Admin"
    routerLink="/admin/manage-mappings/offices"
    routerLinkActive="nav__menu-item-icon_active"
    tooltipInvokeType="hover"
    tooltipPosition="right"
    tooltipSize="lg"
    tooltipType="regular"
  >
    <ng-container *ngTemplateOutlet="svgIconAdmin"></ng-container>
  </a>

  <a
    *hmIfRole="role.SuperAdmin"
    [tooltipHasBeak]="true"
    [tooltipIndent]="10"
    class="nav__menu-item"
    ddsTooltip="Users management"
    routerLink="/admin/users"
    routerLinkActive="nav__menu-item-icon_active"
    tooltipInvokeType="hover"
    tooltipPosition="right"
    tooltipSize="lg"
    tooltipType="regular"
  >
    <ng-container *ngTemplateOutlet="svgIconUserManagement"></ng-container>
  </a>

  <a
    *hmIfRole="[role.Admin, role.SuperAdmin]"
    [tooltipHasBeak]="true"
    [tooltipIndent]="10"
    class="nav__menu-item"
    ddsTooltip="System configuration"
    routerLink="/system-configuration"
    routerLinkActive="nav__menu-item-icon_active"
    tooltipInvokeType="hover"
    tooltipPosition="right"
    tooltipSize="lg"
    tooltipType="regular"
  >
    <ng-container *ngTemplateOutlet="svgIconBuilding"></ng-container>
  </a>
</div>

<div>
  <hm-profile-menu></hm-profile-menu>
</div>

<ng-template #svgIconHome>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M12 3.99219L20.1094 10.3203L18.8672 11.8906L18 11.2344V18.9922H6V11.2344L5.22656 11.8672L4.00781 10.2969L12 3.99219ZM16.0078 17V9.66406L12 6.54688L7.99219 9.66406V17H10.0078V14H13.9922V17H16.0078Z"
    />
  </svg>
</ng-template>

<ng-template #svgIconBuilding>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M16.0078 5V8H19.9922V14H19.0078V18.9922H4.99219V14H4.00781V8H7.99219V5H16.0078ZM13.9922 8V6.99219H10.0078V8H13.9922ZM7.00781 17H16.9922V14H13.0078V15.0078H10.9922V14H7.00781V17ZM13.0078 12.0078H18V9.99219H6V12.0078H10.9922V11H13.0078V12.0078Z"
    />
  </svg>
</ng-template>

<ng-template #svgIconFloor>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M10.0078 6.99219V14H16.9922V6.99219H10.0078ZM7.99219 5H19.0078V15.9922H7.99219V5ZM4.99219 6.99219V18.9922H16.9922V17H7.00781V6.99219H4.99219Z"
    />
  </svg>
</ng-template>

<ng-template #svgIconArea>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99219 6.00781V3.99219H16.0078V11C16.5547 11 17.0234 11.1953 17.4141 11.5859C17.8047 11.9766 18 12.4453 18 12.9922V17H16.0078V20H13.9922V17H10.0078V20H7.99219V17H6V12.9922C6 12.4453 6.19531 11.9766 6.58594 11.5859C6.97656 11.1953 7.44531 11 7.99219 11V6.00781ZM7.99219 12.9922V15.0078H16.0078V12.9922H7.99219ZM10.0078 6.00781V11H13.9922V6.00781H10.0078Z"
      fill="currentColor"
    />
  </svg>
</ng-template>

<ng-template #svgIconCompareBuildings>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M12 12.0078H19.5C19.5 12.3359 19.4766 12.6719 19.4297 13.0156C19.3828 13.3438 19.3125 13.6719 19.2188 14C19.1094 14.3906 18.9688 14.7656 18.7969 15.125C18.6406 15.4844 18.4531 15.8281 18.2344 16.1562C17.8281 16.7812 17.3359 17.3281 16.7578 17.7969C16.1797 18.2656 15.5469 18.6406 14.8594 18.9219C14.1719 19.2031 13.4609 19.3828 12.7266 19.4609C11.9922 19.5391 11.2578 19.5078 10.5234 19.3672C9.80469 19.2109 9.11719 18.9609 8.46094 18.6172C7.80469 18.2734 7.21875 17.8359 6.70312 17.3047C6.17188 16.7734 5.72656 16.1875 5.36719 15.5469C5.02344 14.8906 4.78125 14.1953 4.64062 13.4609C4.5 12.7422 4.46094 12.0156 4.52344 11.2812C4.60156 10.5312 4.78125 9.8125 5.0625 9.125C5.34375 8.4375 5.71875 7.8125 6.1875 7.25C6.67188 6.67188 7.21875 6.17969 7.82812 5.77344C8.15625 5.53906 8.5 5.34375 8.85938 5.1875C9.23438 5.01562 9.61719 4.875 10.0078 4.76562C10.3203 4.6875 10.6406 4.625 10.9688 4.57812C11.3125 4.53125 11.6562 4.50781 12 4.50781V10.1328V12.0078ZM12 14H10.0078V6.875C9.82031 6.95313 9.63281 7.03906 9.44531 7.13281C9.27344 7.21094 9.10156 7.3125 8.92969 7.4375C8.49219 7.73437 8.09375 8.09375 7.73438 8.51562C7.39062 8.9375 7.11719 9.39844 6.91406 9.89844C6.71094 10.3984 6.57812 10.9219 6.51562 11.4688C6.46875 12 6.5 12.5312 6.60938 13.0625C6.70312 13.6094 6.875 14.125 7.125 14.6094C7.39062 15.0781 7.71875 15.5078 8.10938 15.8984C8.5 16.2734 8.92969 16.5938 9.39844 16.8594C9.88281 17.1094 10.3906 17.2891 10.9219 17.3984C11.4531 17.5078 11.9844 17.5391 12.5156 17.4922C13.0625 17.4297 13.5938 17.2891 14.1094 17.0703C14.6094 16.8672 15.0703 16.5938 15.4922 16.25C15.9141 15.9062 16.2734 15.5078 16.5703 15.0547C16.6797 14.8828 16.7812 14.7109 16.875 14.5391C16.9688 14.3672 17.0469 14.1875 17.1094 14H12ZM18.9141 9.125C18.9922 9.29688 19.0547 9.46875 19.1016 9.64062C19.1641 9.79688 19.2188 9.96094 19.2656 10.1328H13.875V4.74219C14.0469 4.78906 14.2109 4.84375 14.3672 4.90625C14.5391 4.95312 14.7031 5.00781 14.8594 5.07031C15.3125 5.25781 15.7422 5.49219 16.1484 5.77344C16.5703 6.03906 16.9531 6.34375 17.2969 6.6875C17.6406 7.04688 17.9453 7.42969 18.2109 7.83594C18.4922 8.24219 18.7266 8.67188 18.9141 9.125Z"
    />
  </svg>
</ng-template>

<ng-template #svgIconNewBuildings>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M12 7.13281L4.66406 9.96875L4.00781 8.11719L12 5L19.9922 8.11719L19.3359 9.96875L12 7.13281ZM4.00781 18.9922H19.9922V17H4.00781V18.9922ZM4.99219 15.0078H7.00781V11H4.99219V15.0078ZM9 9.99219H10.9922V15.0078H9V9.99219ZM13.0078 15.0078H15V9.99219H13.0078V15.0078ZM16.9922 11H19.0078V15.0078H16.9922V11Z"
    />
    <path
      fill="white"
      fill-opacity="0.24"
      d="M12 7.13281L4.66406 9.96875L4.00781 8.11719L12 5L19.9922 8.11719L19.3359 9.96875L12 7.13281ZM4.00781 18.9922H19.9922V17H4.00781V18.9922ZM4.99219 15.0078H7.00781V11H4.99219V15.0078ZM9 9.99219H10.9922V15.0078H9V9.99219ZM13.0078 15.0078H15V9.99219H13.0078V15.0078ZM16.9922 11H19.0078V15.0078H16.9922V11Z"
    />
  </svg>
</ng-template>

<ng-template #svgIconAdmin>
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6875 3.99219L16.4766 5.16406L15.6328 7.17969C15.8516 7.35156 16.0625 7.53906 16.2656 7.74219C16.4688 7.92969 16.6484 8.14062 16.8047 8.375L18.8438 7.53125L19.9922 10.3203L17.9766 11.1641C18.0078 11.4453 18.0234 11.7266 18.0234 12.0078C18.0234 12.2891 18.0078 12.5703 17.9766 12.8516L19.9922 13.6719L18.8438 16.4609L16.8047 15.6172C16.6484 15.8516 16.4688 16.0703 16.2656 16.2734C16.0625 16.4609 15.8516 16.6406 15.6328 16.8125L16.4766 18.8516L13.6875 20L12.8438 17.9609C12.5625 18.0078 12.2812 18.0312 12 18.0312C11.7188 18.0312 11.4375 18.0078 11.1562 17.9609L10.3125 20L7.52344 18.8516L8.36719 16.8125C8.14844 16.6406 7.9375 16.4609 7.73438 16.2734C7.53125 16.0703 7.35156 15.8516 7.19531 15.6172L5.15625 16.4609L4.00781 13.6719L6.02344 12.8516C5.99219 12.5547 5.97656 12.2656 5.97656 11.9844C5.97656 11.7031 5.99219 11.4297 6.02344 11.1641L4.00781 10.3203L5.15625 7.53125L7.19531 8.375C7.35156 8.15625 7.53125 7.94531 7.73438 7.74219C7.9375 7.53906 8.14844 7.35156 8.36719 7.17969L7.52344 5.16406L10.3125 3.99219L11.1562 6.03125C11.4375 5.98438 11.7188 5.96094 12 5.96094C12.2812 5.96094 12.5625 5.98438 12.8438 6.03125L13.6875 3.99219ZM12 15.9922C13.1094 15.9922 14.0547 15.6016 14.8359 14.8203C15.6172 14.0391 16.0078 13.1016 16.0078 12.0078C16.0078 10.8984 15.6172 9.95312 14.8359 9.17188C14.0547 8.39062 13.1094 8 12 8C10.8906 8 9.94531 8.39062 9.16406 9.17188C8.38281 9.95312 7.99219 10.8984 7.99219 12.0078C7.99219 13.1016 8.38281 14.0391 9.16406 14.8203C9.94531 15.6016 10.8906 15.9922 12 15.9922Z"
      fill="currentColor"
    />
  </svg>
</ng-template>

<ng-template #svgIconUserManagement>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9922 6.99219V5C15.1016 5 16.0469 5.39062 16.8281 6.17188C17.6094 6.95313 18 7.89844 18 9.00781C18 10.1016 17.6094 11.0391 16.8281 11.8203C16.0469 12.6016 15.1016 12.9922 13.9922 12.9922V11C14.5547 11 15.0312 10.8047 15.4219 10.4141C15.8125 10.0234 16.0078 9.55469 16.0078 9.00781C16.0078 8.44531 15.8125 7.96875 15.4219 7.57812C15.0312 7.1875 14.5547 6.99219 13.9922 6.99219ZM3 18.9922H4.99219C4.99219 18.1641 5.28125 17.4609 5.85938 16.8828C6.45312 16.2891 7.16406 15.9922 7.99219 15.9922H10.0078C10.8359 15.9922 11.5391 16.2891 12.1172 16.8828C12.7109 17.4609 13.0078 18.1641 13.0078 18.9922H15C15 18.3047 14.8672 17.6562 14.6016 17.0469C14.3359 16.4375 13.9766 15.9141 13.5234 15.4766C13.0859 15.0234 12.5625 14.6641 11.9531 14.3984C11.3438 14.1328 10.6953 14 10.0078 14H7.99219C7.30469 14 6.65625 14.1328 6.04688 14.3984C5.4375 14.6641 4.90625 15.0234 4.45312 15.4766C4.01562 15.9141 3.66406 16.4375 3.39844 17.0469C3.13281 17.6562 3 18.3047 3 18.9922ZM15 15.9922V14H16.0078C16.6953 14 17.3438 14.1328 17.9531 14.3984C18.5625 14.6641 19.0859 15.0234 19.5234 15.4766C19.9766 15.9141 20.3359 16.4375 20.6016 17.0469C20.8672 17.6562 21 18.3047 21 18.9922H19.0078C19.0078 18.1641 18.7109 17.4609 18.1172 16.8828C17.5391 16.2891 16.8359 15.9922 16.0078 15.9922H15ZM9 5C10.1094 5 11.0547 5.39062 11.8359 6.17188C12.6172 6.95313 13.0078 7.89844 13.0078 9.00781C13.0078 10.1016 12.6172 11.0391 11.8359 11.8203C11.0547 12.6016 10.1094 12.9922 9 12.9922C7.89062 12.9922 6.94531 12.6016 6.16406 11.8203C5.38281 11.0391 4.99219 10.1016 4.99219 9.00781C4.99219 7.89844 5.38281 6.95313 6.16406 6.17188C6.94531 5.39062 7.89062 5 9 5ZM9 11C9.54688 11 10.0156 10.8047 10.4062 10.4141C10.7969 10.0234 10.9922 9.55469 10.9922 9.00781C10.9922 8.44531 10.7969 7.96875 10.4062 7.57812C10.0156 7.1875 9.54688 6.99219 9 6.99219C8.45312 6.99219 7.98438 7.1875 7.59375 7.57812C7.20312 7.96875 7.00781 8.44531 7.00781 9.00781C7.00781 9.55469 7.20312 10.0234 7.59375 10.4141C7.98438 10.8047 8.45312 11 9 11Z"
      fill="currentColor"
    />
  </svg>
</ng-template>
